const skillsData = [
    {
        name: "Programming Languages",
        skills: ["java", "js", "ts", "html", "css", "py"]
    }, 
    {
        name: "Front-end",
        skills: ["react", "nextjs", "redux", "angular", "reactivex", "vue", "vite", "apollo", "bootstrap", "materialui", "tailwind", "figma"]
    }, 
    { // "kafka", "rabbitmq",
        name: "Back-end",
        skills: ["spring", "kafka", "hibernate", "express",  "nodejs", "graphql", "postman", "firebase", "linux", "npm"]
    }, 
    {
        name: "DevOps & Deployment",
        skills: ["github", "githubactions", "aws", "docker", "kubernetes", "jenkins", "heroku", "gcp", "vercel"]
    }, 
    {
        name: "Database",
        skills: ["postgres", "mongodb", "mysql"]
    },
    {
        name: "Programming IDEs",
        skills: ["idea", "vscode", "pycharm", "phpstorm", "webstorm", "anaconda", "visualstudio"]
    }
]

export default skillsData;